import React, { FC, ReactNode, useState } from 'react'
import {
    Flex,
    FlexProps,
    Tooltip,
    TooltipProps,
} from '@chakra-ui/react'

interface AndroidTooltipProps {
    children: ReactNode
    containerProps?: FlexProps
    label: string
    placement?: TooltipProps['placement']
    maxWidth?: TooltipProps['maxWidth']
}

export const AndroidTooltip: FC<AndroidTooltipProps> = ({
    label,
    containerProps,
    children,
    placement,
    maxWidth,
}) => {
    const [isToolTipOpen, setIsToolTipOpen] = useState(false)

    return (
        <Flex
            alignItems="center"
            boxSize={8}
            justifyContent="center"
            mr={-2}
            onMouseEnter={() => setIsToolTipOpen(true)}
            onMouseLeave={() => setIsToolTipOpen(false)}
            width='full'
        >
            <Tooltip
                arrowPadding={4}
                arrowSize={8}
                hasArrow
                isOpen={isToolTipOpen}
                label={label}
                maxWidth={maxWidth}
                placement={placement ?? 'bottom-end'}
            >
                <Flex
                    alignItems='center'
                    boxSize={4}
                    justifyContent='center'
                    width='full'
                    {...containerProps}
                >
                    {children}
                </Flex>
            </Tooltip>
        </Flex>
    )
}